import {
	IPayerPersonalData,
	IPayerProfileServiceFieldsData,
	IPaymentPayerFormData,
	IPaymentPayerServiceFieldsData,
	IUserProfileResponse,
	IUserUpdateProfileRequest,
} from 'utils/types';

export const getUserFullName = (data: IUserProfileResponse): string =>
	`${data.lastName ? `${data.lastName} ` : ''}${data.firstName ?? ''}`;

export const getPayerFullName = ({ lastName, firstName, middleName }: IPayerPersonalData): string =>
	[lastName, firstName, middleName]
		.map((value) => value.trim())
		.filter(Boolean)
		.join(' ');

export const getPaymentPayerInitialValues = (profile: IUserProfileResponse): IPaymentPayerFormData => ({
	firstName: profile.firstName ?? '',
	lastName: profile.lastName ?? '',
	middleName: profile.middleName ?? '',
	taxId: profile.taxId ?? '',
	isPayerSameAsUltimateDebtor: true,
	ultimateDebtor: {
		firstName: '',
		lastName: '',
		middleName: '',
		taxId: '',
	},
});

export const getPaymentPayerServiceFieldsData = (
	data: IPaymentPayerFormData
): IPaymentPayerServiceFieldsData => {
	const payer = getPayerProfileServiceFieldsData(data);
	const ultimateDebtor = data.isPayerSameAsUltimateDebtor
		? {
				firstName: payer.first_name,
				lastName: payer.last_name,
				middleName: payer.middle_name,
				taxId: payer.taxId,
		  }
		: data.ultimateDebtor;

	return {
		...payer,
		ultimate_debtor_name: getPayerFullName(ultimateDebtor),
		ultimate_debtor_taxId: ultimateDebtor.taxId.trim(),
	};
};

export const getPayerProfileServiceFieldsData = (
	data: IPaymentPayerFormData
): IPayerProfileServiceFieldsData => ({
	first_name: data.firstName.trim(),
	last_name: data.lastName.trim(),
	middle_name: data.middleName.trim(),
	taxId: data.taxId.trim(),
});

export const getChangedPayerProfileData = (
	profile: IUserProfileResponse,
	data: IPaymentPayerFormData
): IUserUpdateProfileRequest | null => {
	const fields: (keyof Pick<IUserUpdateProfileRequest, 'firstName' | 'lastName' | 'middleName' | 'taxId'>)[] = [
		'firstName',
		'lastName',
		'middleName',
		'taxId',
	];
	const changedData = fields.reduce((result, field) => {
		const value = data[field].trim();
		return value !== (profile[field] ?? '') ? { ...result, [field]: value } : result;
	}, {} as IUserUpdateProfileRequest);

	return Object.keys(changedData).length ? changedData : null;
};

export const fetchUserIp = (): Promise<string> =>
	fetch('https://api.ipify.org?format=json', { method: 'GET' })
		.then((response) => response.json())
		.then((data) => (data as any).ip as string);
